<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.optional{
  text-align: center;
  color: white;
  font-size: 16px;
}

.margin-top{
  margin-top: 40px;
  text-align: center;
}

/* button.trans{
  background-color: rgba(255,255,255,0.2);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
  width: auto;
} */

</style>

<Dialog show="{show}" title="Social Links" height="{500}" buttons="{[{text: 'Cancel', callback: 'cancel', disabled: false, }]}" on:cancel="{ () => show = false }">
  <SocialLinksSelect on:selected="{addLink}"></SocialLinksSelect>
</Dialog>

<div class="bg">
  <div class="title-signup">Add Social Media Links</div>
  <div class="optional">(Optional)</div>
  <div class="margin">
    
    <SocialLinks bind:links="{links}"></SocialLinks>
    
    <div class="margin-top">
      <button class="trans" on:click="{ () => show = true }">+ Add Link</button>
    </div>
        
  </div>
  
  <div class="has-buttons"></div>
  
</div>

<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import SocialLinks from "../../../../components/SocialLinks.svelte";
import NextButton from "../../../../components/NextButton.svelte";
import Dialog from "../../../../components/DialogSlide.svelte";
import SocialLinksSelect from "../../../../components/SocialLinksSelect.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";


import { onMount } from "svelte";
onMount(async () => {
  try {
    // Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  linksSaved = Signup.getPersonalObject("socialLinksSaved");
  links = Signup.getPersonalObject("socialLinks");
  
  if (linksSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let show = false;

let allowSignup = false;
let nextDisabled = true;

let links = [
  {icon: "instagram", link: "@TheGroveLA"},
  {icon: "website", link: "thegrovela.com"},
];
let linksSaved = false;


function addLink(e) {
  // console.log("e.detail:", e.detail);
  links.push(e.detail.link);
  links = links;
  show = false;
}


function check(e) {
  linksSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    // console.log("links:", links);
    Validate.links(links);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (linksSaved == false) {
    // no normalizing just yet.  we might want to implement this though...
    // links = Normalize.links(links); 
    await Signup.saveToPersonalObject("socialLinks", links);
    await Signup.saveToPersonalObject("socialLinksSaved", true);
    await Signup.saveMe("socialLinks");

  }
  push("/signup/profile/personal/location");
}


</script>